<div class="page-container" [dir]="getDir()">
  <!-- Header Section -->
  <div class="header-section">
    <div class="header-left">
      <button class="back-btn" (click)="closeTask()" [title]="'common.backToList' | translate">
        <i class="bi bi-chevron-left"></i>
      </button>
      <div>
        <h2 class="section-title">{{ summary?.number || 'Task Details' }}</h2>
        <span class="task-status" [class]="'status-' + (summary?.status?.replaceAll(' ', '')?.toLowerCase() || 'pending')">
          @if (summary?.status) {
            {{ 'statuses.' + summary?.status| translate }}
          } @else {
            {{ 'common.loading' | translate }}
          }
        </span>
      </div>
    </div>
  </div>

  <!-- Error State -->
  <!-- @if (errorMessage) {
    <div class="alert alert-danger">
      {{ errorMessage }}
    </div>
  } -->

  <!-- Success Message -->
  <!-- @if (successMessage) {
    <div class="alert alert-success">
      {{ successMessage }}
    </div>
  } -->

  <!-- Loading State -->
  @if (isLoading) {
    <div class="loading-state">
      <div class="spinner"></div>
      <p>{{ 'common.loading' | translate }}</p>
    </div>
  }

  <!-- Tab Navigation -->
  @if (!isLoading && taskData) {
    <div class="tabs-container">
      <div class="custom-tab-nav">
        <!-- Tab 1: Initial Form -->
        <div
          class="tab-pill"
          [class.active]="activeTab === 'initialForm'"
          [class.disabled]="!areTabsNavigable"
          (click)="areTabsNavigable && selectTab('initialForm')">
          <i class="bi bi-file-text-fill"></i>
          <span>{{ 'task.tab.initialForm' | translate }}</span>
        </div>
        <!-- Tab 2: Action (hidden for myRequests) -->
        @if (showTaskFormTab) {
          <div
            class="tab-pill"
            [class.active]="activeTab === 'form'"
            (click)="selectTab('form')">
            <i class="bi bi-pencil-square"></i>
            <span>{{ 'task.tab.action' | translate }}</span>
          </div>
        }
        <!-- Tab 3: Task History -->
        <div
          class="tab-pill"
          [class.active]="activeTab === 'history'"
          [class.disabled]="!areTabsNavigable"
          (click)="areTabsNavigable && selectTab('history')">
          <i class="bi bi-clock-history"></i>
          <span>{{ 'task.tab.history' | translate }}</span>
        </div>
      </div>
    </div>
  }

  <!-- Tab Content -->
  @if (!isLoading && taskData) {
    <div class="tab-content" [attr.data-direction]="slideDirection">
      <!-- Tab 1: Initial Form -->
      @if (activeTab === 'initialForm') {
        <div class="tab-pane active">
          <app-task-initial-form-tab
            [requestTypeLogicalId]="requestTypeLogicalId"
            [formData]="initialFormData"
            [taskRequest]="taskRequest"
            [pageType]="pageType"
            [requestId]="requestId"
            [taskId]="taskId"
            [isReadonly]="isReadonly">
          </app-task-initial-form-tab>
        </div>
      }
      <!-- Tab 2: Action (hidden for myRequests) -->
      @if (showTaskFormTab && activeTab === 'form') {
        <div class="tab-pane active">
          <app-task-form-tab
            [formSchema]="taskFormSchema"
            [availableActions]="availableActions"
            [taskRequest]="taskRequest"
            [requestId]="requestId"
            [taskId]="taskId"
            [requestTypeLogicalId]="requestTypeLogicalId"
            [isReadonly]="allFieldsDisabled"
            [pageType]="pageType"
            (actionExecuted)="onActionExecuted($event)"
            (formDataChanged)="$event">
          </app-task-form-tab>
        </div>
      }
      <!-- Tab 3: Task History -->
      @if (activeTab === 'history') {
        <div class="tab-pane active">
          <app-task-history-tab
            [previousActions]="previousActions"
            [pageType]="pageType"
            [requestId]="requestId"
            [taskId]="taskId">
          </app-task-history-tab>
        </div>
      }
    </div>
  }
</div>
